import * as React from 'react';

/**
 * Threshold below which views should prefer a stacked / vertical layout.
 * Includes phones (375 px) AND tablet portrait (768 px), since the latter
 * still can't comfortably show wide multi-column layouts like the
 * Now-Next-Later Kanban (audit H5).
 */
const NARROW_BREAKPOINT = 1024;

export function useIsNarrowViewport(): boolean {
    const [isNarrow, setIsNarrow] = React.useState<boolean | undefined>(undefined);

    React.useEffect(() => {
        const mql = window.matchMedia(`(max-width: ${NARROW_BREAKPOINT - 1}px)`);
        const check = () => setIsNarrow(window.innerWidth < NARROW_BREAKPOINT);
        check();
        if (mql.addEventListener) {
            mql.addEventListener('change', check);
            return () => mql.removeEventListener('change', check);
        }
        // Older Safari fallback.
        window.addEventListener('resize', check);
        return () => window.removeEventListener('resize', check);
    }, []);

    return !!isNarrow;
}
